var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationChatbubbles = function SvgSimpleIllustrationChatbubbles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "simple-illustration__chatbubbles_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__chatbubbles_svg__st2{fill:none;stroke:#002140;stroke-linecap:round;stroke-linejoin:round}.simple-illustration__chatbubbles_svg__st3{fill:#048659}")), /*#__PURE__*/React.createElement("path", {
    d: "M11 32.7s-5-7-3.1-11.4C9.8 17 12.5 10.1 25.3 10c12.8 0 16.8 11.9 16.2 15.9-.7 4-6.2 10.7-12.6 11.7s-9.4-.1-9.4-.1-6.1 3.5-12.4 1.6c0 0 3.2-4 3.9-6.4z",
    style: {
      fill: "#5cdca4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 21s1.8 9-4.7 13.2c-5.6 3.3-8.5 4.3-16 3.8 0 0 .7 4.6 5.8 7.6s11.7 3.7 14.7 2.3c0 0 8.5 2.9 12.5 1.4 0 0-3.9-5.1-3.8-6.7 0 0 4.5-4.2 3.3-10S45.8 21.3 41 21z",
    style: {
      fill: "#ec572f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__chatbubbles_svg__st2",
    d: "M11 32.5c-2.1-2.3-3.3-5.2-3.3-8.4 0-7.8 7.5-14.1 16.8-14.1s16.8 6.3 16.8 14.1-7.5 14.1-16.8 14.1c-1.6 0-3.1-.2-4.6-.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__chatbubbles_svg__st2",
    d: "M11 32.5c-.4 3.3-4 6.7-4 6.7s8.9.9 12.9-1.5M19.9 37.7c1.8 6.2 8.4 10.7 16.4 10.7 1.6 0 3.1-.2 4.6-.5M49.8 42.7c2.1-2.3 3.3-5.2 3.3-8.4 0-6.3-5-11.7-11.8-13.5M49.8 42.7c.4 3.3 4 6.7 4 6.7s-8.9.9-12.9-1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__chatbubbles_svg__st3",
    d: "M17.5 27.2c1.3 0 2.3-1 2.3-2.3 0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3zM24.6 27.2c1.3 0 2.3-1 2.3-2.3 0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3zM31.7 27.2c1.3 0 2.3-1 2.3-2.3 0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3z"
  })));
};
export default SvgSimpleIllustrationChatbubbles;